import React from 'react';
import './css/index.css';

const Loader = ({ color }) => {
	return <div className="loader" style={{ borderTop: `4px solid ${color}` }}></div>;
};

export default Loader;
